import styled from '@emotion/styled';
import { font, remCalc, palette, icon, animations, mediaQueries, sizeMap } from '../../css';
import { StyledSvg, StyledIcon } from '../../UI/Icon/Icon.css';

const { blink } = animations;

const widths = {
    small: remCalc(50),
    medium: remCalc(85),
    large: remCalc(112),
};

const padding = {
    small: remCalc(3, 7),
    medium: remCalc(5, 15),
    large: remCalc(8, 10),
};

const iconSize = {
    small: icon.size.xxsmall,
    medium: icon.size.xsmall,
    large: icon.size.small,
};

const fontSize = {
    small: remCalc(sizeMap.xxs * 0.9),
    medium: remCalc(sizeMap.xxs * 0.9),
    large: font.size.xs,
};

export const getConfigSize = (config, size, modifier = 0) => {
    if (modifier !== 0) {
        const keys = Object.keys(config);
        const index = keys.indexOf(size);
        if (index === -1) {
            return undefined;
        }
        const sizeIndex = index + modifier;
        return config[keys[Math.max(0, Math.min(keys.length - 1, sizeIndex))]];
    }
    return config[size];
};

const StyledLabelText = styled('span')(
    () => ({
        marginRight: remCalc(5),

        [mediaQueries.medium]: {
            marginRight: remCalc(10),
        },
    }),
    ({ live }) =>
        !live
            ? {
                  marginRight: 0,

                  [mediaQueries.medium]: {
                      marginRight: 0,
                  },
              }
            : {},
);

const timeAnimation = 700;
const animationDuration = 5000;
const iterationCount = Math.ceil(animationDuration / timeAnimation);
const StyledIcons = styled('span')(() => ({
    position: 'relative',

    '& :nth-child(2)': {
        animation: `${blink} ${timeAnimation}ms`,
        animationDelay: `-${timeAnimation * 2}ms`,
        animationIterationCount: iterationCount,
    },

    '& :nth-child(3)': {
        animation: `${blink} ${timeAnimation}ms alternate-reverse`,
        animationIterationCount: iterationCount,
    },
}));

const StyledLabel = styled('span')(
    () => ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: font.family.body,
        backgroundColor: palette('white'),
        color: palette('black'),
        textAlign: 'center',

        fontWeight: font.weight.bold,
    }),
    ({ size }) => ({
        padding: getConfigSize(padding, size, -1),
        minWidth: getConfigSize(widths, size, -1),

        [mediaQueries.medium]: {
            padding: getConfigSize(padding, size),
            minWidth: getConfigSize(widths, size),
        },

        [StyledLabelText]: {
            fontSize: getConfigSize(fontSize, size, -1),

            [mediaQueries.medium]: {
                fontSize: getConfigSize(fontSize, size),
            },
        },

        [StyledIcons]: {
            display: 'inline-block',
            verticalAlign: 'middle',
            position: 'relative',
            ...getConfigSize(iconSize, size, -1),

            [mediaQueries.medium]: getConfigSize(iconSize, size),
        },

        [StyledIcon]: {
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'inline-flex',

            [StyledSvg]: {
                ...getConfigSize(iconSize, size, -1),

                [mediaQueries.medium]: getConfigSize(iconSize, size),
            },
        },
    }),
);

export { StyledLabel, StyledLabelText, StyledIcons };
